import { localStorageGet, localStorageSet } from '@/helpers/localStorage'

type TCollapseOptionsState = Record<string, Record<string, boolean>>

const LOCAL_STORAGE_SUFFIX = '-options-collapsed'

export const getCurrentSchemeOptionCollpsedState = (): TCollapseOptionsState => {
  return JSON.parse(
    localStorageGet(
      `${window.location.toString()}${LOCAL_STORAGE_SUFFIX}`,
      true,
    ) || '{}',
  )
}

export const setCurrentSchemeOptionCollpsedState = (
  data: TCollapseOptionsState,
): void => {
  localStorageSet(
    `${window.location.toString()}${LOCAL_STORAGE_SUFFIX}`,
    JSON.stringify(data),
  )
}
